import { Box } from '@careguide/theme'
import styled from 'styled-components'

export const Container = styled(Box)`
  text-align: center;
  justify-content: center;
`
